import axios from 'axios'
import config from '@/assets/config.json'
import msalConfig from './AuthServiceConfig'
import { msalInstance } from './AuthService'

const { apiUrl, functions } = config;

export const api = axios.create({
  baseURL: apiUrl
})

// Set customer ID if one already exists.
const storedCustomerId = localStorage.getItem('tpa:primary-customer-id');
if (typeof storedCustomerId === 'string' && storedCustomerId !== '' && storedCustomerId !== 'null') {
  setCustomerId(storedCustomerId);
} else {
  localStorage.removeItem('tpa:primary-customer-id')
}

api.interceptors.request.use(async (config) => {
  const activeAccount = msalInstance.getActiveAccount();

  const request = {
    scopes: msalConfig.resources.api.resourceScope,
    account: activeAccount,
    forceRefresh: false
  }

  const tokenResponse = await msalInstance.acquireTokenSilent(request).catch(async (error) => {
    await msalInstance.acquireTokenPopup(request);
  })

  config.headers.Authorization = 'Bearer ' + tokenResponse.accessToken;

  return config;
}, (error) => {
  return Promise.reject(error);
})

export function setCustomerId(id) {
  api.defaults.headers.common['Customer-Id'] = id;
  console.log('Set customer ID to', id);
}

export async function syncExternalTasks(customerId) {
  const url = `${functions.url}/sync/${customerId}${functions.code ? '?code=' + functions.code : ''}`;
  return await fetch(url);
}